<script>

    import { short_country_name } from "$lib/universal/lib.js";
    import { reg_json } from "$lib/static/reg_json.js";
    import { unp_json } from '$lib/static/unp_json.js';
    import { tcc_json } from '$lib/static/tcc_json.js';
    import Flag from "$lib/Flag.svelte";
    let {
        hoveredRegIntId,
        hoveredRegType
    } = $props();

    let [countryId, countryName, regId, regionName] =
        $derived(hoveredRegType == 'tcc' ?
            getRegionNameByIntId(hoveredRegIntId, 'tcc_json', tcc_json) :
            getRegionNameByIntId(hoveredRegIntId));

    function getRegionNameByIntId(int_id, sourceType = 'reg_json', arr = reg_json, countryId = '', countryName = '', level = 0) {
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].int_id === int_id) {
                const id = arr[i].id;
                const regionName = arr[i].name;


                if(id !== 'CRIMEA' && !id.startsWith('EH') && countryName) {
                    if(countryId === id && countryName === arr[i].name) {
                        if(unp_json[countryId]?.dependent && ['AU', 'CN', 'DK', 'FI', 'NL', 'NZ', 'GB', 'FR', 'US'].includes(unp_json[countryId].dependent)) {
                            return [unp_json[countryId].dependent, short_country_name(unp_json[unp_json[countryId].dependent].name), id, regionName];
                        } else {
                            return [id, regionName, '', ''];
                        }
                    }
                    return [countryId, countryName, id, regionName];
                } else {
                    if(arr[i]?.un && arr[i].un !== 'ZZ' && id !== 'TW' && id !== arr[i].un) {
                        if(id.startsWith('X')) {
                            return [id, regionName];
                        } else if (id.startsWith('EH')) {
                            return ['EH', regionName];
                        } else {
                            return [arr[i].un, short_country_name(unp_json[arr[i].un].name), id, regionName];
                        }
                    }

                    return [id, regionName];
                }
            }

            if (arr[i].db) {
                // level == 0 is for macroregs, and we don't whan mixin them into the result
                const val = getRegionNameByIntId(int_id, sourceType, arr[i].db, level ? arr[i].id : '', level ? short_country_name(arr[i].name) : '', level + 1);
                if(Array.isArray(val) && val.length > 0) {
                    return val;
                }
            }
        }

        return [];
    }
</script>
{#if hoveredRegIntId}
<div id=hovered-region-name>
    <Flag reg={countryId} width=auto/>{#if regId != countryId}&hairsp;<Flag reg={regId} width=auto/>{/if} {countryName}
    {#if regionName && regionName != countryName} &mdash; {regionName}{/if}
    {#if import.meta.env.DEV}[{hoveredRegIntId} {countryId} {regId} ({hoveredRegType})]{/if}
</div>
{:else}
<div id=hovered-region-name>&nbsp;</div>
{/if}
<style>
#hovered-region-name {
    font-size: 0.9em;
    padding-bottom: 0.1em;
}
</style>
